import React from "react";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import useTimerThreshold from "hooks/useTimerThreshold";
import { InstantDoubleValue } from "api/model/dataset/InstantDoubleValue";
import UniversalTableDatasetButtonComponent from "./UniversalTableDatasetButtonComponent";
import { IUniversalDatasetTableRow } from "./interfaces";

type DatasetButtonProps = {
  datasetId?: string;
  columnIndex: number;
  rowData: IUniversalDatasetTableRow;
  dataset: DatasetDataInfoResponse;
  data?: InstantDoubleValue | null;
  time: Date;
  compactMode?: boolean;
  maxAge?: number;
};

const UniversalTableDatasetButtonWrapper = ({
  datasetId,
  columnIndex,
  rowData,
  dataset,
  data,
  time,
  compactMode,
  maxAge,
}: DatasetButtonProps & { dataset: DatasetDataInfoResponse }) => {
  const { isExpired } = useTimerThreshold(maxAge, time?.getTime?.() ?? 0);

  return (
    <UniversalTableDatasetButtonComponent
      id={datasetId ?? ""}
      columnIndex={columnIndex}
      rowData={rowData}
      compactMode={compactMode}
      dataset={dataset}
      data={data}
      time={time}
      isExpired={isExpired}
    />
  );
};

export default UniversalTableDatasetButtonWrapper;
